import { useContext } from "react";
import { ThemeContext } from "@imaginelearning/mps-ux-component-library";

const useTheme = () => {
  const { theme, setTheme } = useContext(ThemeContext);

  return { theme, setTheme };
};

export default useTheme;
